module.exports = __webpack_public_path__ + "static/img/polaroid_frame.4460ee72.svg";